import { render, staticRenderFns } from "./HomeworkMobile.vue?vue&type=template&id=bd90f72e&scoped=true&"
import script from "./HomeworkMobile.vue?vue&type=script&lang=js&"
export * from "./HomeworkMobile.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkMobile.vue?vue&type=style&index=0&id=bd90f72e&prod&lang=scss&scoped=true&"
import style1 from "./HomeworkMobile.vue?vue&type=style&index=1&id=bd90f72e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd90f72e",
  null
  
)

export default component.exports